import React, { useState } from 'react'
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Position from "components/Position";
import Button from "components/Button";
import { useTranslation } from "react-i18next";
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import PartnersTable from '../../tables/Partners/PartnersTable';
import { CircularProgress } from '@material-ui/core';
import TablePagination from '../../paginations/table/SimpleTaablePagination';
import history from '../../utils/history';
import ArchivedPartnerModal from '../../modals/ArchivedPartnerModal';

const PartnersView = (props) => {
    const { t } = useTranslation("partners");
    const { loading, partners, paginationAction, paginationOptions, archivedPartner } = props;
    const [openModal, setOpenModal] = useState(false);
    const [partner, setPartner] = useState(null);

    return (
      <GridContainer justify="center">
        <GridItem xs={10}>
          <Position rigth>
            <Button
              color={"primary"}
              onClick={() => {
                history.push('/partners/new')
              }}
            >
              {t("partners.newPartners")}
            </Button>
          </Position>
        </GridItem>
        <GridItem xs={10}>
          <Card>
            <CardHeader>
              <CardIcon color="info">
                <SupervisorAccountIcon />
              </CardIcon>
              <h4>{t("partners.title")}</h4>
            </CardHeader>
            <CardBody>
              <TablePagination
                data={
                  partners && partners.getAllPartners
                    ? partners.getAllPartners
                    : []
                }
                paginationAction={paginationAction}
                filter={paginationOptions}
              />
              {loading ? (
                <div style={styles.progressCnt}>
                  <CircularProgress style={styles.progress} />
                </div>
              ) : (
                <PartnersTable
                  setPartner={setPartner}
                  setOpenModal={setOpenModal}
                  partners={
                    partners && partners.getAllPartners
                      ? partners.getAllPartners
                      : []
                  }
                />
              )}
            </CardBody>
          </Card>
        </GridItem>
        <ArchivedPartnerModal 
          partner={partner}
          openModal={openModal}
          setOpenModal={() => {
            setOpenModal(false);
          }}
          archivedPartner={archivedPartner}
        />
      </GridContainer>
    );
}

const styles = {
    progressCnt: {
      width: "100px !important",
      marginRight: "50%",
      marginLeft: "50%",
    },
    progress: {
      margin: "16px",
    },
  };
export default PartnersView;
